import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative min-h-screen flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lazyload" }, null, -1)

import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
} from 'vue';
import {
  useRoute,
} from 'vue-router';
import {
  viewportBreakpoint,
} from './helpers';
import BusNotification from '@/components/App/BusNotification.vue';
import FooterComponent from '@/components/App/FooterComponent.vue';
import HeaderComponent from '@/components/NavBar/HeaderComponent.vue';
import {
  useStore,
} from '@/store';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


let storageEventHandler: (e: StorageEvent) => void;
let resizedBreakpointEventHandler: (e: Event) => void;

const route = useRoute();
const appStore = useStore.app;

const showDefaultHeader = computed(() => {
  const { fullPath } = route;
  return !fullPath.startsWith('/auth')
    && !fullPath.startsWith('/admin');
});

const showDefaultFooter = computed(() => {
  const { fullPath } = route;
  return showDefaultHeader.value
    && !fullPath.startsWith('/user');
});

onBeforeMount(() => {
  storageEventHandler = (e: StorageEvent): void => {
    if (e.key === 'token') {
      // local storage token changed
      console.log(`Key Changed: ${e.key}`);
      window.sessionStorage.removeItem('token');
      window.location.reload();
    }
  };
  resizedBreakpointEventHandler = (e: Event): void => {
    const resizedBreakpoint = viewportBreakpoint();
    if (resizedBreakpoint !== appStore.breakpoint) {
      appStore.breakpoint = resizedBreakpoint;
    }
  };
  window.addEventListener('resize', resizedBreakpointEventHandler);
  window.addEventListener('storage', storageEventHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('storage', storageEventHandler);
  window.removeEventListener('resize', resizedBreakpointEventHandler);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(showDefaultHeader))
      ? (_openBlock(), _createBlock(HeaderComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createVNode(BusNotification),
      _createVNode(_component_RouterView)
    ]),
    (_unref(showDefaultFooter))
      ? (_openBlock(), _createBlock(FooterComponent, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})